import clsx from 'clsx';
import React from 'react';
import { Corner, Fit, Shadow } from '../../utils/utils';
import uiConfig from '../../data/uiConfig';

interface ImgProps {
  src: string;
  isBackground?: boolean;
  width?: number | string;
  height?: number | string;
  corner?: Corner;
  shadow?: Shadow;
  fit?: Fit;
  alt?: string;
  filter?: string | 'brightness' | 'blur' | 'none';
  opacity?: string;
  centered?: boolean;
  fullWidth?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export const Img: React.FC<ImgProps> = ({
  src,
  width = 'full',
  height = 'auto',
  corner = uiConfig.img.corner as Corner,
  fit = uiConfig.img.fit as Fit,
  shadow = uiConfig.img.shadow as Shadow,
  alt = '',
  filter = 'none',
  opacity = 'opacity-50',
  centered = false,
  fullWidth = false,
  className = '',
  children
}) => {
  return (
    <div className={clsx(
      centered && 'text-center',
      fullWidth && 'w-full',
      className
    )}>
      <div className={clsx('relative inline-block',
        fullWidth && 'w-full',
      )}>
        {filter && (
          <div
          className={clsx(
            "absolute inset-0",
            corner,
            (typeof filter === 'string' && filter !== 'none' && filter !== 'blur' && filter !== 'brightness' &&
              `${filter} ${opacity}`),
            )}
            aria-hidden="true"
            />)}
        <img
          src={src}
          alt={alt}
          className={clsx(
            shadow,
            corner,
            filter === 'blur' && 'blur-xs',
            filter === 'brightness' && 'brightness-110',
            typeof width === 'string' && width,
            typeof height === 'string' && height,
          )}
          style={{
            width: typeof width === 'number' ? `${width}px` : undefined,
            height: typeof height === 'number' ? `${height}px` : undefined,
            objectFit: fit !== 'none' ? fit : undefined,
          }}
        />
        {children}
      </div>
    </div>
  );
};